/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
} from '@angular/core';

// The action bar shared by forum topics and articles (FORUMS_ARTICLES_REDESIGN.html "Action bar"): like with its
// count, the comment count, then share, subscribe, hide and report where allowed. Pages can project their own
// moderator actions (a ⋯ menu) at the end with [itemActionsEnd].
@Component({
  selector: 'ut-item-actions',
  templateUrl: './item-actions.component.html',
  styleUrls: ['./item-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ItemActionsComponent {
  @Input({ required: true }) item: any;
  // The signed-in user, or null; report isn't offered on your own item.
  @Input() user: any;
  @Input({ required: true }) shareUrl: string;
  @Input() commentCount = 0;
  // The topic page shows the count only in the thread heading.
  @Input() showCommentCount = true;
  // Hide changed item.state.
  @Output() stateChanged = new EventEmitter<void>();

  get canReport(): boolean {
    return !!this.item.current_user_permissions?.flag && this.item.user?.id !== this.user?.id;
  }
}
